import { SPONSOR_BOOST } from '@/domain/center.js'

export const adjustSponsorTier = (sponsorTier: number): number => {
  return SPONSOR_BOOST[sponsorTier] || 0
}
